import { BandNav } from "components/bandNav"
import { CardActivity } from "components/cardActivity"
import { CarouselVision } from "components/carouselVision"
import { Footer } from "components/footer"
import { useEffect } from "react"
import { Container, Image } from "react-bootstrap"
import { logEvent } from "firebase/analytics";
import { analytics } from "config/firebase"

export const AboutUs = () => {
  useEffect(() => {
    logEvent(analytics, 'page_aboutUs');
  }, [])
  return (
    <>
      {/* <BandNav /> */}
      <Image width={"100%"} fluid src="images/cover-hospital-600xauto.jpg" />
      <CarouselVision />
      <div
        className="text-center pt-2"
        style={{
          fontSize: "2em",
          color: "white",
          background: "linear-gradient(to right, #6a3093, #a044ff)" }}
      >
        <span className="text-shadow-drop-br">ข่าวสารและกิจกรรม</span>
      </div>
      <CardActivity />
      <div
        style={{
          backgroundImage: `url(${
            process.env.PUBLIC_URL + "images/linebg3.png"
          })`,
          height: "auto",
          width: "100%",
          backgroundRepeat: "no-repeat",
          backgroundPositionX: "center",
          backgroundSize: "unset",
        }}
      >
        <div className="container">
          <div className=" text-center">
            <div className="col-12 col-md-12 col-lg-12 col-xl-12">
              <h2 style={{ color: "#743d90" }}>รายชื่อคณะกรรมการ</h2>
            </div>
          </div>
          <div className="row">
            <Image src="images/member.jpg" />
          </div>
        </div>
      </div>
      <div
        style={{
          height: "auto",
          width: "100%",
          backgroundColor: "#e9e9e9",
        }}
      >
        <div
          style={{
            backgroundImage: `url(${
              process.env.PUBLIC_URL + "images/bglinecover.png"
            })`,
            height: "auto",
            width: "100%",
            backgroundRepeat: "no-repeat",
            backgroundPositionX: "center",
            backgroundSize: "unset",
          }}
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-md-12 col-lg-12 col-xl-12 text-center">
                <h2
                  style={{
                    color: "#743d90",
                    marginTop: "30px",
                    marginBottom: "20px",
                  }}
                >
                  สารจากผู้บริหาร
                </h2>
              </div>
              <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="text-center">
                      <img
                        src="images/boss.png"
                        alt=""
                        style={{
                          width: "100%",
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="conten-mssage-txt text-center">
                      <span style={{ fontSize: "100px" }}>“</span>
                      <p style={{ marginTop: "-60px", marginBottom: "-20px" }}>
                      มูลนิธิโรงพยาบาลนครพิงค์ เป็นองค์กรสาธารณกุศล รับบริจาคเงินและทุนทรัพย์ เพื่อสนับสนุนกิจกรรมสาธารณะประโยชน์ของโรงพยาบาลนครพิงค์,จัดหาเครื่องมือและอุปกรณ์ทางการแพทย์ เพื่อ ใช้ในการช่วยเหลือผู้ป่วยที่ขาดแคลนทุนทรัพย์,ขาดโอกาสในการเข้าถึงการรักษา รวมถึงสนับสนุนการวิจัยและพัฒนาบุคลากรของโรงพยาบาลนครพิงค์
                      </p>
                      <span style={{ fontSize: "100px" }}>”</span>
                    </div>
                    <div
                      style={{
                        textAlign: "center",
                        color: "#5f5f5f",
                        lineHeight: "1em",
                        margin: "10px",
                        marginTop: "-60px",
                      }}
                    >
                      <p>
                        นพ.ธำรง หาญวงศ์
                        <br />
                        ประธานกรรมการ มูลนิธิ รพ.นครพิงค์
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
